// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2u-Ql","box":"WorkspacesBox_box__3_Q9h","node":"WorkspacesBox_node__2XcJU"};